module.exports = __webpack_public_path__ + "img/bg-element-round-small.97bf7790.png";